import { getWidgetStructureByAppData } from '../editor/remoteStructureFetcher/remoteStructureFetcher';
export class MasterStructureFetcher {
    constructor(editorSDK) {
        this.editorSDK = editorSDK;
        this.cache = {};
    }
    purgeCache() {
        this.cache = {};
    }
    async fetchMasterStructure(widgetRef) {
        const editorSDK = this.editorSDK;
        const compData = (await editorSDK.components.data.get('token', {
            componentRef: widgetRef,
        }));
        const appDefinitionId = compData.applicationId || compData.appDefinitionId;
        const appData = (await editorSDK.tpa.app.getDataByAppDefId('token', appDefinitionId));
        const settings = typeof compData.settings === 'string'
            ? JSON.parse(compData.settings)
            : compData.settings || {};
        const widgetId = settings.type;
        if (!this.cache[widgetId]) {
            this.cache[widgetId] = await getWidgetStructureByAppData(appData, widgetId, undefined);
        }
        return this.cache[widgetId];
    }
}
//# sourceMappingURL=masterStructureFetcher.js.map